import { Actions } from './payment-purposes.actions'
import { fromJS } from 'immutable'
import * as PaymentPurposesTypes from './payment-purposes.types'

export const initialState = fromJS({
  list: {
    isLoading: false,
    shouldReload: false,
    data: [],
    queryParams: {
      page: 1,
      page_size: 10,
    },
    total: 0,
    results: 0,
  },
  createPaymentPurpose: {
    isLoading: false,
    validationErrors: {},
    data: {},
  },
  updatePaymentPurpose: {
    isLoading: false,
    validationErrors: {},
    data: {},
  },
})

export function paymentPurposesReducer(state = initialState, action: Actions) {
  switch (action.type) {
    case PaymentPurposesTypes.UPDATE_PAYMENT_PURPOSE_REQUEST: {
      return state.setIn(['updatePaymentPurpose', 'isLoading'], true)
    }

    case PaymentPurposesTypes.UPDATE_PAYMENT_PURPOSE_SUCCESS: {
      return state.setIn(['updatePaymentPurpose', 'isLoading'], false)
    }

    case PaymentPurposesTypes.UPDATE_PAYMENT_PURPOSE_FAILURE: {
      return state.setIn(['updatePaymentPurpose', 'isLoading'], false)
    }

    case PaymentPurposesTypes.CREATE_PAYMENT_PURPOSE_REQUEST: {
      return state.setIn(['createPaymentPurpose', 'isLoading'], true)
    }

    case PaymentPurposesTypes.CREATE_PAYMENT_PURPOSE_SUCCESS: {
      return state.setIn(['createPaymentPurpose', 'isLoading'], false)
    }

    case PaymentPurposesTypes.CREATE_PAYMENT_PURPOSE_FAILURE: {
      return state.setIn(['createPaymentPurpose', 'isLoading'], false)
    }

    case PaymentPurposesTypes.DELETE_PAYMENT_PURPOSE_REQUEST: {
      return state
    }

    case PaymentPurposesTypes.DELETE_PAYMENT_PURPOSE_SUCCESS: {
      return state.setIn(['list', 'shouldReload'], true)
    }
    case PaymentPurposesTypes.DELETE_PAYMENT_PURPOSE_FAILURE: {
      return state
    }

    case PaymentPurposesTypes.FETCH_PAYMENT_PURPOSES_REQUEST: {
      return state
        .setIn(['list', 'isLoading'], true)
        .setIn(['list', 'shouldReload'], false)
    }

    case PaymentPurposesTypes.FETCH_PAYMENT_PURPOSES_SUCCESS: {
      return state
        .setIn(['list', 'isLoading'], false)
        .setIn(['list', 'data'], fromJS(action.payload))
        .setIn(['list', 'total'], fromJS(action.total))
        .setIn(['list', 'results'], fromJS(action.results))
    }

    case PaymentPurposesTypes.FETCH_PAYMENT_PURPOSES_FAILURE: {
      return state.setIn(['list', 'isLoading'], false)
    }

    case PaymentPurposesTypes.FETCH_PAYMENT_PURPOSE_REQUEST: {
      return state.setIn(['updatePaymentPurpose', 'isLoading'], true)
    }

    case PaymentPurposesTypes.FETCH_PAYMENT_PURPOSE_SUCCESS: {
      return state
        .setIn(['updatePaymentPurpose', 'isLoading'], false)
        .setIn(
          ['updatePaymentPurpose', 'data'],
          fromJS(action.payload).delete('streetType').delete('id'),
        )
    }

    case PaymentPurposesTypes.FETCH_PAYMENT_PURPOSE_FAILURE: {
      return state.setIn(['updatePaymentPurpose', 'isLoading'], false)
    }

    case PaymentPurposesTypes.UPDATE_FIELD:
      let fields = []

      if (action.path === '') {
        fields = action.field.split('.')
      } else {
        fields = action.path.split('.').concat(action.field.split('.'))
      }
      const value = action.value

      if (fields.length === 1) {
        return state.set(fields[0], fromJS(value))
      }
      return state.setIn(fields, fromJS(value))
    case PaymentPurposesTypes.SET_DEFAULT_DATA:
      const path = action.path || ''
      return state.setIn(path.split('.'), initialState.getIn(path.split('.')))

    default:
      return state
  }
}
